import { render } from "./Offcuts.vue?vue&type=template&id=4f8ba8f2"
import script from "./Offcuts.vue?vue&type=script&lang=js"
export * from "./Offcuts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__